// src/layouts/PublicLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNav from '../components/layout/TopNav';
import SiteFooter from '../components/layout/SiteFooter';

export default function PublicLayout() {
    return (
        <div className="public">
            <TopNav />

            <main className="public__main">
                <Outlet />
            </main>

            <SiteFooter />
        </div>
    );
}